export const downloadFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const parseCSVFileName = (contentDisposition, fallbackName) => {
  if (!contentDisposition) return `${fallbackName}.csv`;

  const match = /filename="?([^"]+)"?/.exec(contentDisposition);
  return match?.[1] ? decodeURIComponent(match[1]) : `${fallbackName}.csv`;
};

export const extractCSVContent = (text) => {
  const lines = text.split(/\r?\n/);
  const firstNonEmptyIndex = lines.findIndex((line) => line.trim() !== "");

  if (firstNonEmptyIndex === -1) return { reportTitle: "", csvContent: text };

  const reportTitle = lines[firstNonEmptyIndex]
    .replace(/^"/, "")
    .replace(/"$/, "")
    .trim();

  const csvStartIndex = firstNonEmptyIndex + 1;
  const start =
    lines[csvStartIndex]?.trim() === "" ? csvStartIndex + 1 : csvStartIndex;
  const csvContent = lines.slice(start).join("\n");

  return { reportTitle, csvContent };
};
